var Fuoriscenalibri_Maps = {

    geocoder : null,
    map : null,
    input : null,
    searchBox : null,
    markers : [],

    init : function() {
        if (jQuery("#map").length) {
            google.maps.event.addDomListener(window, 'load', Fuoriscenalibri_Maps.initGoogleMapsSearch);
        }

        if (jQuery("#map-event").length) {
            google.maps.event.addDomListener(window, 'load', Fuoriscenalibri_Maps.initGoogleMapsEvent);
        }
    },

    initGoogleMapsEvent : function() {
        var map = new google.maps.Map(document.getElementById('map-event'), {
            center: {lat: 41.2031579, lng: 8.2121164},
            zoom: 5,
            mapTypeId: 'roadmap',
            styles: [
                {
                    featureType: 'poi.business',
                    stylers: [{visibility: 'off'}]
                },
                {
                    featureType: 'transit',
                    elementType: 'labels.icon',
                    stylers: [{visibility: 'off'}]
                }
            ]
        });
        var geocoder = new google.maps.Geocoder();
        var location = jQuery("#map-event-location").text();
        geocoder.geocode( { 'address': location }, function(results, status) {
            if (status == 'OK') {
                map.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: map,
                    zoom: 5,
                    position: results[0].geometry.location
                });

                var bounds = new google.maps.LatLngBounds();
                if (results[0].geometry.viewport) {
                    bounds.union(results[0].geometry.viewport);
                } else {
                    bounds.extend(marker.getPosition());
                }

                map.fitBounds(bounds);
            }
        });
    },

    initGoogleMapsSearch : function() {
        var geocoder = new google.maps.Geocoder();
        var map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: 41.2031579, lng: 8.2121164},
            zoom: 5,
            mapTypeId: 'roadmap'
        });
        var input = document.getElementById('eventmeta-location');
        var searchBox = new google.maps.places.SearchBox(input);
        var autocomplete = new google.maps.places.Autocomplete(input);
        autocomplete.bindTo('bounds', map);

        geocoder.geocode( { 'address': input.value }, function(results, status) {
            if (status == 'OK') {
                map.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: map,
                    zoom: 5,
                    position: results[0].geometry.location
                });

                var bounds = new google.maps.LatLngBounds();
                if (results[0].geometry.viewport) {
                    bounds.union(results[0].geometry.viewport);
                } else {
                    bounds.extend(marker.getPosition());
                }

                map.fitBounds(bounds);
            }
        });

        var marker = new google.maps.Marker({
            map: map,
            anchorPoint: new google.maps.Point(0, -29)
        });

        autocomplete.addListener('place_changed', function() {
            marker.setVisible(false);
            var place = autocomplete.getPlace();
            if (!place.geometry) {
                return;
            }

            // If the place has a geometry, then present it on a map.
            if (place.geometry.viewport) {
                map.fitBounds(place.geometry.viewport);
            } else {
                map.setCenter(place.geometry.location);
                map.setZoom(17);  // Why 17? Because it looks good.
            }
            marker.setPosition(place.geometry.location);
            marker.setVisible(true);
        });

        // Bias the SearchBox results towards current map's viewport.
        map.addListener('bounds_changed', function() {
            searchBox.setBounds(map.getBounds());
        });
    }

};

jQuery(function() {

    Fuoriscenalibri_Maps.init();

});